import { render } from "./WeeklyOutloads.vue?vue&type=template&id=5e0c6ce3"
import script from "./WeeklyOutloads.vue?vue&type=script&lang=ts"
export * from "./WeeklyOutloads.vue?vue&type=script&lang=ts"
script.render = render

export default script